export default __webpack_public_path__ + "static/media/courses.8df6efc6.jpg";